<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-4"><a href="#/OEBPS/The_Hanging_Wood2#Contents-A">Dedication</a></p>
<p class="body-center-italic"><em class="italic">Dedicated to the memory of Joan Edwards</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Hanging_Wood-3.vue?867a84f4